import { Directive, HostBinding, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaObserver } from '@angular/flex-layout';
import { Subscription } from 'rxjs';

import { FuseMatchMediaService } from '../../services/match-media.service';
import { FuseMatSidenavHelperService } from './fuse-mat-sidenav.service';

@Directive({
    selector: '[fuseMatSidenavHelper]',
})
export class FuseMatSidenavHelperDirective implements OnInit, OnDestroy {
    matchMediaSubscription: Subscription;
    @HostBinding('class.mat-is-locked-open') isLockedOpen = true;
    @Input('fuseMatSidenavHelper') id: string;
    @Input('mat-is-locked-open') matIsLockedOpenBreakpoint: string;

    constructor(
        private fuseMatSidenavService: FuseMatSidenavHelperService,
        private fuseMatchMedia: FuseMatchMediaService,
        public mediaObserver: MediaObserver,
        private matSidenav: MatSidenav,
    ) {
    }

    ngOnInit() {
        this.fuseMatSidenavService.setSidenav(this.id, this.matSidenav);

        if (this.mediaObserver.isActive(this.matIsLockedOpenBreakpoint || "quick-panel")) {
            this.isLockedOpen = true;
            this.matSidenav.mode = 'side';
            this.matSidenav.toggle(true);
        } else {
            this.isLockedOpen = false;
            this.matSidenav.mode = 'over';
            this.matSidenav.toggle(false);
        }

        this.matchMediaSubscription = this.fuseMatchMedia.onMediaChange.subscribe(() => {
            if (this?.matIsLockedOpenBreakpoint) {
                if (this.mediaObserver.isActive(this?.matIsLockedOpenBreakpoint)) {
                    this.isLockedOpen = true;
                    this.matSidenav.mode = 'side';
                    this.matSidenav.toggle(true);
                } else {
                    this.isLockedOpen = false;
                    this.matSidenav.mode = 'over';
                    this.matSidenav.toggle(false);
                }
            }
            else {
                this.isLockedOpen = false;
                this.matSidenav.mode = 'over';
                this.matSidenav.toggle(false);
            }
        });
    }

    ngOnDestroy() {
        if (this.matchMediaSubscription) { this.matchMediaSubscription.unsubscribe(); }
    }
}

// tslint:disable-next-line: max-classes-per-file
@Directive({
    selector: '[fuseMatSidenavToggler]',
})
export class FuseMatSidenavTogglerDirective {
    @Input('fuseMatSidenavToggler') id;

    constructor(private fuseMatSidenavService: FuseMatSidenavHelperService) {
    }

    @HostListener('click')
    onClick() {
        this.fuseMatSidenavService.getSidenav(this.id).toggle();
    }
}
